module.exports = __webpack_public_path__ + "static/media/rindish.497d104d.jpg";